import { Resolution } from './resolution.model';

export class Purpose {
  purpose_id: number;
  name: string;
  description: string;
  is_preview: boolean;
  resolution: Resolution;

  /**
   * Constructor
   *
   * @param purpoose
   */
  constructor(purpose) {
    this.purpose_id  = purpose.purpose_id  || 0;
    this.name        = purpose.name        || '';
    this.description = purpose.description || '';
    this.is_preview  = purpose.is_preview  || false;
    this.resolution  = purpose.resolution  || null;
  }
}
